// extracted by mini-css-extract-plugin
module.exports = {"value":"NumberDisplay_value__3sBmX","numbercontainer":"NumberDisplay_numbercontainer__37ZEF","number":"NumberDisplay_number__2RARv"};